import React from 'react';
export const GridContext  = React.createContext([[0]]);
export const ManipulationContext = React.createContext({});
export const ExecutionContext = React.createContext({speed:-1, running:false});
 
